import { getLotteryTypes } from '@/service/lottery';

export const state = {
  routerPage: 'pk10',
  headTabs: []
};

export const actions = {
  async fetchHeadTabs({ dispatch }) {
    const info = await getLotteryTypes();
    if (info.result === 'ok') {
      dispatch('setHeadTabs', info.data);
    }
  },
  setHeadTabs ({commit}, tabs) {
    if (!tabs.length) return;
    commit('SET_HEAD_TABS', tabs);
  }
};

export const mutations = {
  ['SET_HEAD_TABS'] (state, tabs) {
    state.headTabs = tabs;
  }
};

export const getters = {
  headTabs: state => state.headTabs
};



// WEBPACK FOOTER //
// ./src/pages/home/store.js